import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Image, Modal, Spin, Space, Skeleton, Button, Radio, Flex, Dropdown, Empty, List, Pagination, notification } from 'antd';
import { LoadingOutlined, RightOutlined, LeftOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useTranslation } from 'react-i18next';
import { useBrowser } from '../../contexts/BrowserContext';
import { CLIENT_TYPE } from '../../config';
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_PRODUCT_MODAL_DATA_LIST, FETCH_DISLIKE, FETCH_LIKE, FETCH_PRODUCT_LIST, FETCH_PRODUCT_MODAL_DATA_LIST } from "../../redux/actions";
import { setSelectedId } from "../../redux/slices/selectItemDrawerMenu";
import { setSelectedProductId } from "../../redux/slices/selectProductId";
import { Link, useNavigate } from "react-router-dom";
import { ROUTER } from "../../router/constants";
import CategoryFilesList from "./CategoryFilesList";
import ProductModal from './ProductModal';
import { setCurrentPage } from '../../redux/slices/currentPageSlice';
import { setLikeFormId } from '../../redux/slices/likeFormIdSlice';

const SingleCollectionList = ({ sectionTitle, view, data, header, meta }) => {




    const isAuthenticated = useSelector((state) => state.initialize.isAuthenticated);
    const loading = useSelector((state) => state.loading);




    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showMoreOptions, setShowMoreOptions] = useState(false);
    const [profileType, setProfileType] = useState("all");
    const [productId, setProductId] = useState(null);
    const [like, setLike] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [currentPages, setCurrentPages] = useState(1);
    const { browser } = useBrowser();
    const [renderOptions, setRenderOptions] = useState({ psb: "planar", uvw: 50, hue_shift: 0, saturation: 0, brightness: 0, contras: 0 });
    const [likedItems, setLikedItems] = useState({});


    const { t } = useTranslation();

    const navigate = useNavigate()


    const handlePageChange = (page) => {
        setCurrentPages(page);
        dispatch(setCurrentPage(page));
    };


    const handleSelectedProductId = (id, selectId, categoryName) => {

        dispatch({ type: CLEAR_PRODUCT_MODAL_DATA_LIST })
        setProductId(id)
        dispatch(setSelectedProductId(id));
        let selectedIndex;
        let files = data?.id === selectId && data?.files
        selectedIndex = files?.findIndex(item => item.id === id)
        setSelectedIndex(selectedIndex)
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });

        if (data.is_collection) {
            const collectionRoute = ROUTER.SHOW_SINGLE_COLLECTION.replace(':collectionName', categoryName);
            navigate(`${collectionRoute}`)
        }

    };



    const handleSelectedCategoryId = (id) => {
        dispatch(setSelectedId(id));
    }


    const toggleLike = (id, isLiked) => {
        dispatch(setLikeFormId(id));
        setLikedItems((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
        if (!isAuthenticated) {
            notification.error({
                message: "To register likes for forms, please Login first.",
                description: "You are not logged in yet. Your likes will not be registered in the system.",
                placement: "topRight",
            });
            setTimeout(() => {
                setLikedItems({})
            }, 5000)
        } else {
            dispatch({ type: isLiked ? FETCH_DISLIKE : FETCH_LIKE });
        }
        dispatch({ type: FETCH_PRODUCT_MODAL_DATA_LIST });
    };



    /*useEffect(() => {
        if (showCategory && filters.categories?.length > 0) {
            const items = filters.categories.map((item, index) => {
                let key = String(index + 1);
                return {
                    key: `sub${key}`,
                    label: item.category.title,
                    children: item.items.length > 0 ? item.items.map((subItem, subIndex) => {
                        const subKey = item.category.title + "/" + subItem.category.title.replace(" ", "_");
                        return {
                            key: subKey,
                            label: subItem.category.title
                        };
                    }) : {},
                };
            });
            items.unshift({
                key: `all_categories`,
                label: t('product.all_categories')
            });

            setCategoryMenu(items);
        }
    }, []);*/

    useEffect(() => {

        if (selectedProduct != null && typeof selectedProduct.category !== "undefined") {
            var mainCategory = selectedProduct.category.split("/")[0].toLowerCase();
            if (mainCategory === "object") {
                setProfileType("object");
            } if (mainCategory === "texture") {
                setProfileType("texture");
            } else if (mainCategory === "2d") {
                setProfileType("2d");
            } else if (mainCategory === "sweep maker") {
                setProfileType("sweep_maker");
            } else {
                setProfileType("all");
            }
        } else {
            setProfileType("all");
        }
    }, [selectedProduct]);



    useEffect(() => {
        if (selectedProduct != null) {
            switch (renderOptions.psb) {
                case "planar":
                    browser.planar(selectedProduct);
                    break;
                case "spherical":
                    browser.spherical(selectedProduct);
                    break;
                case "box":
                    browser.box(selectedProduct);
                    break;
                default:
                    break;
            }
        }
    }, [renderOptions.psb]);


    const handleInfiniteScroll = () => {
        console.log("fetch more");
        //fetchMoreProducts();
    };

    const generateKey = (pre) => {
        return `${pre}_${new Date().getTime()}_${Math.random()}`;
    }

    useEffect(() => {
        dispatch(setSelectedId(null));
    }, []);


    return loading ? (

        <>
            {sectionTitle !== "" && typeof sectionTitle !== "undefined" ? <h2 className='section-title'>{sectionTitle}</h2> : null}
            {
                view === "list" ?
                    <Spin
                        indicator={
                            <LoadingOutlined
                                style={{
                                    fontSize: 24,
                                }}
                                spin
                            />
                        }
                    />
                    :
                    <Row gutter={[10, 10]} >
                        {
                            Array(16).fill(0).map((_, index) => (
                                <Col xs={24} sm={12} md={8} lg={6} key={index}>
                                    <Card
                                        hoverable
                                        cover={
                                            <Skeleton.Image
                                                active
                                                className="card-image"
                                                style={{ objectFit: 'cover' }}
                                            />
                                        }
                                        className="product-card loading"
                                    >
                                    </Card>
                                </Col>
                            ))
                        }
                    </Row>

            }
        </>
    ) : (

        <InfiniteScroll
            dataLength={12}
            next={handleInfiniteScroll}
            hasMore={false}
            scrollableTarget="content-scroll-target"
            loader={<Spin
                className='infinite-scroll-loading'
                indicator={
                    <LoadingOutlined
                        className='loading-spin'
                        spin
                    />
                }
            />}

        >

            {
                view === "list" ? <List className='project-list'
                    renderItem={(product) => (
                        <List.Item key={product?.id} style={{ cursor: "pointer" }}>
                            <List.Item.Meta onClick={() => { setOpen(true); setSelectedProduct(product); }}
                                title={product.title}
                            />
                        </List.Item>
                    )}
                /> :

                    <Row gutter={[10, 10]} className='scroll-row'>
                        {
                            loading ?
                                (
                                    Array(15).fill(() => (
                                        <Col xs={24} sm={12} md={8} lg={6}>
                                            <Skeleton active />
                                        </Col>
                                    ))
                                ) :
                                (
                                    data ?
                                        <div style={{ width: '100%' }}>
                                            <Flex justify='space-between' align={'center'} style={{ width: '100%' }}>

                                                {
                                                    view !== "list" ?
                                                        <h2 className='section-title'
                                                            style={{ marginBottom: '20px', marginLeft: '5px' }}>{data.name ? data.name : header}</h2>
                                                        : <></>
                                                }

                                            </Flex>
                                            <Row style={{ width: '100%' }}>
                                                <CategoryFilesList
                                                    files={data.files ? data.files : data}
                                                    handleSelectedProductId={handleSelectedProductId}
                                                    // likeAndDislike={likeAndDislike}
                                                    setOpen={setOpen}
                                                    like={like}
                                                    setLike={setLike}
                                                    categoryId={data.id}
                                                    likedItems={likedItems}
                                                    toggleLike={toggleLike}
                                                />
                                            </Row>

                                        </div>
                                        :
                                        <Empty className='products-empty' />
                                )

                        }
                    </Row>
            }

            <ProductModal selectedIndex={selectedIndex} setSelectedIndex={setSelectedIndex} likedItems={likedItems}
                toggleLike={toggleLike} data={data} open={open} setOpen={setOpen} profileType={profileType} />

            {
                header &&
                <Pagination
                    current={currentPages}
                    pageSize={15}
                    total={meta?.total}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                    style={{ marginTop: '50px', marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }}
                />
            }


        </InfiniteScroll >

    );
}

export default SingleCollectionList
